import { IVisit, Visit } from "./visit.model"

export interface IPassesResponse {
  canceled: IVisit[];
  declined: IVisit[];
  overdue: IVisit[];
  active: IVisit[];
  history: IVisit[];
}


export class PassesResponse {
  canceled: Visit[];
  declined: Visit[];
  overdue: Visit[];
  active: Visit[];
  history: Visit[];

  [key: string]: Visit[]; 

  constructor(data: IPassesResponse) {
    this.canceled = data.canceled.map(
      e => new Visit(e)
    );
    
    this.declined = data.declined.map(
      e => new Visit(e)
    );
    
    this.overdue = data.overdue.map(
      e => new Visit(e)
    );
    
    this.active = data.active.map(
      e => new Visit(e)
    );
    
    this.history = data.history.map(
      e => new Visit(e)
    );
    
  }

}
